<template>
  <div class="foot">
      <p>主办单位/版权所有：中国中小企业协会　 备案号/经营许可证号：京ICP备08005153号</p>
      <p class="address">地址：北京市西城区月坛南街59号新华大厦六层　 邮政编码：100045 技术支持：麦秸</p>
      <p class="copyright">京公网安备 11010202007291号</p>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    components: {
    },
    computed: {},
    mounted(){},
    activated(){},
    methods: {

    }
  }
</script>
<style lang="less" scoped>
.foot{
    background: #2C2C2C;
    padding: 80px 0px;
    text-align: center;
     p{
       font-size: 12px;
       line-height: 17px;
       color: #fff;
     }
    .address{
      margin: 20px 0px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pubilc/footer/index.vue